<template>
  <div>
    <div v-if="this.$store.state.isLogin">
      <el-button type="primary" class="user-login-button" icon="el-icon-user"
                 v-on:click="$router.push('/user')">
        个人中心
      </el-button>
    </div>
    <div v-else>
      <el-button type="primary" class="user-login-button" icon="el-icon-user"
                 v-on:click="$router.push('/login')">
        登陆/注册
      </el-button>
    </div>
  </div>
</template>

<script>

import store from "@/components/dataStorePersisted";

export default {
  name: "HeaderUser",
  store

}
</script>

<style scoped>


.user-login-button {
  position: absolute;
  top: 10px;
  right: 15px;
  background-color: #FF8A00;
  border-color: #FF8A00;
  border-radius: 0;
}

.user-login-button:hover {
  background-color: #FF8A00 !important;
  border-color: #FF8A00 !important;
}

.user-login-button:focus {
  background-color: #FF8A00 !important;
  border-color: #FF8A00 !important;
}

</style>